const ACCOUNT_HASH = 'i3Za5UfsMbko8b2ee_CZBw'

// FormatImageURL is used to tranform an imageID to the correct Cloudflare API image link
// This is usefull because, this way, we don't need to apply this logic everytime we want to
// render an image from cloudflare api.
export const FormatImageURL = (imageID: string, variant: string = 'public') =>
  `https://imagedelivery.net/${ACCOUNT_HASH}/${imageID}/${variant}`
